import * as React from 'react';
import Modal from '@mulesoft/anypoint-components/lib/Modal';
import ModalHeader from '@mulesoft/anypoint-components/lib/ModalHeader';
import ModalBody from '@mulesoft/anypoint-components/lib/ModalBody';
import ModalFooter from '@mulesoft/anypoint-components/lib/ModalFooter';
import Button from '@mulesoft/anypoint-components/lib/Button';
import './SettingsBodyModal.css'

export type ValueProps = {
  opened: boolean
}

export type EventProps = {
  onClose: () => void
  onApply: () => void
}

export type Props = ValueProps & EventProps

export type ModalProps = EventProps & {
  type: string,
  headerText: string,
  bodyText: string,
  cancelButtonText: string,
  confirmButtonText: string,
}

export const SettingsBodyApplyModal = (props: Props) => {
  if (props.opened) {
    return (
      <SettingsBodyModal
        type="apply"
        headerText="Apply Changes"
        bodyText={'Applying changes will restart your application. Click "Apply" if you want to continue with the restart.'}
        cancelButtonText="Cancel"
        confirmButtonText="Apply"
        onClose={props.onClose}
        onApply={props.onApply}
      />
    );
  }
  return null;
}

export const SettingsBodyDisableModal = (props: Props) => {
  if (props.opened) {
    return (
      <SettingsBodyModal
        type="disable"
        headerText="Disable Anypoint Monitoring"
        bodyText={'Disabling Anypoint Monitoring will restart your application. Click "Disable" if you want to continue with the restart.'}
        cancelButtonText="Cancel"
        confirmButtonText="Disable"
        onClose={props.onClose}
        onApply={props.onApply}
      />
    );
  }
  return null;
}

export const SettingsBodyModal = (props: ModalProps) => {
    return (
      <Modal
        className={`settings-body-modal ${props.type}-modal`}
        onClickOverlay={props.onClose}
        testId={`cloudhub-settings-${props.type}-modal`}
      >
        <ModalHeader className="settings-body-modal-header" testId={`cloudhub-settings-${props.type}-modal-header`} onClose={props.onClose}>
          <h1>{props.headerText}</h1>
        </ModalHeader>
        <ModalBody className="settings-body-modal-body" testId={`cloudhub-settings-${props.type}-modal-body`}>
          <p>{props.bodyText}</p>
        </ModalBody>
        <ModalFooter className="settings-body-modal-footer" testId={`cloudhub-settings-${props.type}-modal-footer`}>
          <Button
            className="settings-body-modal-cancel-button"
            testId={`cloudhub-settings-${props.type}-modal-cancel-button`}
            kind="tertiary"
            onClick={props.onClose}
            noFill={true}
          >
            {props.cancelButtonText}
          </Button>
          <Button
            className="settings-body-modal-confirm-button"
            testId={`cloudhub-settings-${props.type}-modal-confirm-button`}
            kind="primary"
            onClick={props.onApply}
          >
            {props.confirmButtonText}
          </Button>
        </ModalFooter>
      </Modal>
    );
}
